<template>
    <div class="fullscreen background"></div>
    <div id="wrapper">
        <header class="section">
            <a :href="homeRoute" class="no-link"> <h1> Super Tactico Online </h1> </a>
            <p class="game-description"> Build your loadout. Fight at sea, air and land. Defend your flag. Capture enemy's flag. Win the game. </p>
        </header>
        <main>
            <slot> </slot>
        </main>
        <footer>
            <p> ©2022 Sahar Lando <br> Original board game designed by Orda Industries Ltd. </p>
        </footer>
    </div>
</template>

<script>
const config = require('../config');
export default {
    data() {
        return {
            homeRoute: config.production ? config.productionRoot : '/',
        }
    },
}
</script>

<style scoped>
body, html{
    background-color: #222831 !important; 
}
::selection{
    background-color: rgba(0, 0, 0, 0.212);
}
#wrapper{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    font-family: 'Jost', arial;
}
h1{
    text-align: center;
    color: #00ADB5 !important;
    opacity: 0.8;
    user-select: none;
}
footer{
    position: absolute;
    bottom: 0;
    left: 0; 
    right: 0; 
    margin-left: auto; 
    margin-right: auto; 
}
footer>p{
    color: #EEEEEE;
    opacity: 0.8;
    text-align: center;
}
.game-description{
    text-align: center;
    padding-bottom: 5px;
    opacity: 0.8;
}
header {
    margin-top: 12px;
    transition: 0.15s;
}
.section:hover{
    background-color: #393E46;
}
.section{
    background-color: #393e46c4;
    color: #EEEEEE;
    border-radius: 8px;
}
:slotted(.menu-btn){
    min-width: fit-content;
    width: 155px;
    background-color: #00ADB5;
    opacity: 0.8;
    margin-bottom: 10px;
    padding: 5px 15px 5px 15px;
    border-radius: 8px;
    font-size: 1.2em;
    cursor: pointer;
    user-select: none;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
    text-decoration: none;
    display: block;
    color: #222831;
    transition: opacity 0.15s;
}
:slotted(.menu-btn:hover){
    opacity: 0.9;
}
.background{
    background-color: #222831;
}
.no-link{
    text-decoration: none;
}
</style>
